import React from 'react';

import { Route, Switch, useRouteMatch } from 'react-router-dom';

import UserPage from './UserPage';
import UserAdmin from '../../SettingsPanels/UsersAdmin';

const UsersRoutes: React.FC = () => {
    const { path } = useRouteMatch();

    console.log('UsersRoutes path', path);
    return (
        <>
            <Switch>
                <Route exact path={`${path}`} component={UserAdmin} />
                <Route exact path={`${path}/:userId`} component={UserPage} />
            </Switch>
        </>
    );
};

export default UsersRoutes;
